import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 10.3999L9.2 13.5999L14 6.3999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheck;
